// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"8b0c980b","596":"ee6700b9","983":"ce8f8930"}[chunkId] + ".chunk.js";
};